<template>
  <div>
    <!--    <div style="display: block; width: 100%; height: 20px;">-->
    <!--      <span class="pull-left select-other-info">包装比例: {{ optionItem.packingRatio || '暂无' }}</span>-->
    <!--    </div>-->
    <el-row class="select-other-info" v-if="optionItem.productSubclassCode ">
      <span class="core-goods-title">子类编码:  </span>
      {{ optionItem.productSubclassCode }}
    </el-row>
    <el-row class="select-other-info" v-if="optionItem.productName ">
      <span class="core-goods-title">产品名称:  </span>
      {{ optionItem.productName }}
    </el-row>
    <el-row class="select-other-info" v-if="optionItem.code ">
      <span class="core-goods-title">货品编号:  </span>
      {{ optionItem.code }}
    </el-row>
    <el-row class="select-other-info" v-if="optionItem.productCode ">
      <span class="core-goods-title">产品编码:  </span>
      {{ optionItem.productCode }}
    </el-row>
    <el-row class="select-other-info" v-if="optionItem.productSpecification ">
      <span class="core-goods-title">规格:  </span>
      {{ optionItem.productSpecification }}
    </el-row>
    <el-row class="select-other-info" v-if="optionItem.wholePackageAmount ">
      <span class="pull-left select-other-info ml-15" v-if="optionItem.wholePackageAmount">
        包装: {{ optionItem.productPackingSpecification }}
        <dict :dict-group="'measurementUnit'" :dict-key="optionItem.measurementUnit"></dict>/
        <dict :dict-group="'shipmentPackingUnit'" :dict-key="optionItem.wholePackageUnit"></dict>
      </span>
    </el-row>
    <el-row class="select-other-info" v-if="optionItem.typeId ">
     <span class="pull-right select-other-info">
        <dict :dict-group="'typeId'" :dict-key="optionItem.typeId"></dict><span
       v-show="optionItem.typeId === '1' && optionItem.vaccineSign">-<dict :dict-group="'vaccineSign'"
                                                                           :dict-key="optionItem.vaccineSign"></dict></span>
      </span>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'manageGoodsOption',
  props: {
    optionItem: {
      required: true,
      type: Object
    }
  }
};
</script>
